import { CompanyUserType } from 'lib/api_ts/companiesApi';
import { getDeliverablesByProjectId, getMilestonesByProjectId, getTasksByProjectIdStreamId, StreamType } from 'lib/api_ts/overviewApi';
import React from 'react';
import Gantt from './Gantt';
import { getOeTaskStatus } from 'lib/api';
import { Loading } from '@components/atomic/atoms';
import { useQueries, useQuery } from '@tanstack/react-query';

interface OverviewProps {
	activeKey: string;
	projectId: number;
	streams?: StreamType[];
	users?: CompanyUserType[];
}

export type TaskStatusMapType = {
	code: string;
	name: string;
	description: string | null;
}[];

const Overview: React.FC<OverviewProps> = ({ activeKey, projectId, streams = [], users = [] }) => {
	const { data: milestonesData, isPending: isMilestonesPending } = useQuery({
		queryKey: ['milestones', projectId],
		queryFn: () => getMilestonesByProjectId(projectId.toString()),
	});
	const { data: deliverablesData, isPending: isDeliverablesPending } = useQuery({
		queryKey: ['deliverables', projectId],
		queryFn: () => getDeliverablesByProjectId(projectId.toString()),
	});

	const { data: taskStatusMapData, isPending: isTaskStatusMapPending } = useQuery({
		queryKey: ['oeTaskStatus'],
		queryFn: getOeTaskStatus,
	});

	const tasksQueries = useQueries({
		queries: streams.map((stream) => ({
			queryKey: ['tasks', projectId, stream.id],
			queryFn: () => getTasksByProjectIdStreamId(projectId.toString(), stream.id.toString()),
			enabled: streams.length > 0,
		})),
	});

	const isLoading = isMilestonesPending || isDeliverablesPending || isTaskStatusMapPending || tasksQueries.some((query) => query.isPending);

	const milestones = milestonesData ?? [];
	const deliverables = deliverablesData ?? [];
	const taskStatusMap = taskStatusMapData?.data ?? [];
	const tasks = tasksQueries.every((taskData) => taskData.data) ? tasksQueries.flatMap((taskData) => taskData.data || []) : [];

	return isLoading ? (
		<Loading fixedHeight="50vh" />
	) : (
		<Gantt
			activeKey={activeKey}
			milestones={milestones}
			deliverables={deliverables}
			tasks={tasks}
			users={users}
			streams={streams}
			taskStatusMap={taskStatusMap}
		/>
	);
};

export default Overview;
